import { CalendarMonth } from "@mui/icons-material";
import { TextField, TextFieldProps } from "@mui/material";
import Flatpickr from "react-flatpickr";

type MuiFlatpickrProps = {
  value?: Date | string | null;
  onChange?: (date: Date[]) => void;
  placeholder?: string;
  readonly?: boolean;
} & Omit<TextFieldProps, "value" | "onChange">;

const MuiFlatpickr = ({
  value,
  onChange,
  placeholder,
  readonly = false,
  ...textFieldsProps
}: MuiFlatpickrProps) => {
  return (
    <Flatpickr
      value={value as any}
      onChange={onChange}
      options={{
        dateFormat: "m/d/Y",
        animate: true,
        clickOpens: !readonly,
      }}
      render={({ defaultValue }, ref) => (
        <TextField
          {...textFieldsProps}
          inputRef={ref}
          defaultValue={defaultValue}
          placeholder={placeholder}
          size="small"
          InputProps={{
            startAdornment: <CalendarMonth fontSize="small" />,
            sx: {
              "& input": {
                textAlign: "left",
                marginLeft: "8px",
              },
            },
          }}
        />
      )}
    />
  );
};
export default MuiFlatpickr;
